import type { JsonValue } from './agentConfigurationShared';

export type DifyConfigurationProps = {
    agent?: unknown;
    configId?: string;
    configVersion?: number | string;
    configVersionId?: string;
    hasConfigurationVersions?: boolean;
    activeVersionConfigurationId?: string;
    onVersionUpdated?: () => void;
};

export const EMPTY_DIFY_CONFIG: Record<string, JsonValue> = {};

export const passthroughLabel = (value: string) => value;

export const getAddFieldPathKey = (path: string[]) => (path.length ? path.join('.') : '__root__');

export const accordionItemClassNames = {
    base: 'bg-content1 border border-divider rounded-lg shadow-none overflow-hidden',
    heading: 'w-full',
    trigger: 'w-full py-3 min-h-[52px]',
    titleWrapper: 'pl-0 ml-0',
    title: 'text-base font-semibold text-default-800 m-0',
    indicator: 'text-default-400',
};

export const getAgentIdentity = (agent: unknown): { aiworkerId: string; agentName: string } => {
    if (!agent || typeof agent !== 'object') {
        return { aiworkerId: '', agentName: 'Agent' };
    }
    const record = agent as Record<string, unknown>;
    const aiworkerId = typeof record.aiworker_id === 'string' ? record.aiworker_id : '';
    const name = typeof record.name === 'string' ? record.name : '';
    const aiworkerName = typeof record.aiworker_name === 'string' ? record.aiworker_name : '';
    return { aiworkerId, agentName: name || aiworkerName || 'Agent' };
};

export const getConfigurationErrorMessage = (error: unknown, fallback: string): string => {
    if (!error || typeof error !== 'object') {
        return fallback;
    }
    const record = error as Record<string, unknown>;
    const data = record.data;
    if (data && typeof data === 'object' && data !== null && 'message' in data && data.message != null) {
        return String(data.message);
    }
    if (record.reason != null) {
        return String(record.reason);
    }
    if (record.message != null) {
        return String(record.message);
    }
    return fallback;
};

export const getUpdatedArrayEntryValue = (entry: JsonValue, next: string): JsonValue => {
    if (typeof entry === 'number') {
        return Number(next || 0);
    }
    if (typeof entry === 'boolean') {
        return next === 'true';
    }
    return next;
};
